import styled from '@emotion/styled';

export const Sticky = styled.div`
  z-index: 99;
  position: sticky;
  top: 0;
`;
